import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import ImportHubCard from '../components/molecules/ImportHubCard.jsx';
import { PageHeader } from '../components/molecules/PageHeader.jsx';
import { useImportHubV2 } from '../hooks/ff/index.js';
import { useImportHubPaths } from '../hooks/useImportHubRouteApi.js';

export function ImportHub() {
  const { t } = useTranslation('@myn/import-hub');
  const paths = useImportHubPaths();
  const isImportHubV2 = useImportHubV2();

  return (
    <>
      <PageHeader
        title={t('Data Import Hub')}
        description={t(
          'Your central hub for seamless data imports into MINT. Here, you can choose between different import options tailored to your needs.',
        )}
      />
      <h3 className={typographyVariants({ variant: 'h3' })}>
        {t('Import types')}
      </h3>
      <div className="my-4 flex items-stretch gap-6">
        <ImportHubCard
          title={t('Performance data import')}
          description={t(
            'Import performance data files from external sources and map them with platform items.',
          )}
          linkProps={{
            to: paths.performance,
            search: { tab: 'imports' },
            preload: 'intent',
          }}
          variant="compact"
        />
      </div>
      <h3 className={cn(typographyVariants({ variant: 'h3' }), 'mb-4')}>
        {t('Tools')}
      </h3>
      <div className="flex items-stretch gap-6">
        {!isImportHubV2 && (
          <ImportHubCard
            title={t('Custom metrics')}
            description={t(
              'Create and tailor metrics to your needs that will be available also in the Reporting module.',
            )}
            linkProps={{
              to: paths.customMetrics,
              preload: 'intent',
            }}
          />
        )}
        <ImportHubCard
          title={t('Trusted emails')}
          description={t(
            'Manage trusted email addresses for auto-import. This includes external or system emails that are not added as users in this workspace.',
          )}
          linkProps={{
            to: paths.whitelistedEmails,
            preload: 'intent',
          }}
        />
      </div>
    </>
  );
}
